"use client";

import { motion, useScroll, useSpring } from "framer-motion";
import { useEffect, useState } from "react";

/**
 * Horizontal scroll progress bar that shows reading progress
 * Positioned under the blog navigation and animates as user scrolls
 * The bar height is 4px (h-1) and positioned right below the navigation
 */
export function ScrollProgressBar() {
  const [mounted, setMounted] = useState(false);
  const [navHeight, setNavHeight] = useState(80); // Default height
  const { scrollYProgress } = useScroll();

  // Add spring physics for smooth animation
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  useEffect(() => {
    setMounted(true);

    // Detect navigation height dynamically
    const nav = document.querySelector("nav");
    if (nav) {
      const updateNavHeight = () => {
        setNavHeight(nav.offsetHeight);
      };

      updateNavHeight();

      // Update on resize
      window.addEventListener("resize", updateNavHeight);
      return () => window.removeEventListener("resize", updateNavHeight);
    }
  }, []);

  if (!mounted) return null;

  return (
    <div
      className="fixed left-0 right-0 z-40 h-1 bg-gray-200"
      style={{ top: `${navHeight}px` }}
    >
      <motion.div
        className="h-full bg-brand-blue origin-left"
        style={{ scaleX }}
      />
    </div>
  );
}
